import React, {Component} from 'react'
import RelabelsTable from './table/RelabelsTable'

class RelabelsPage extends Component {
    render() {
        const {partner} = this.props
        return <div className="RelabelsPage">
            <RelabelsTable partner={partner}/>
        </div>
    }
}

export default RelabelsPage